export default __webpack_public_path__ + "static/media/JU.07efbf00.JPG";